import React, { useEffect, useState } from "react";
import { getMemoryTreeList, getMemoryTreeSingle, getCurrentPackageUserModule } from "../../../services/api";
import MemoryTreeInside from "./memoryTreeInside";
import ModuleHeader from "../../moduleHeader";

export default function MemoryTree({ id, moduleId, isOwner }) {
  const [showScanner, setShowScanner] = useState(false);
  const [showExample, setShowExample] = useState(false);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [packageData, setPackageData] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [isHeaderExpanded, setIsHeaderExpanded] = useState(false);

  // Paket verisini çek
  useEffect(() => {
    if (!id) return;

    const fetchPackageData = async () => {
      try {
        const data = await getCurrentPackageUserModule(id, 9); // MemoryTree moduleId: 9
        setPackageData(data);
      } catch (error) {
        console.error("Paket verisi alınamadı:", error);
      } finally {
        setPageLoading(false);
      }
    };

    fetchPackageData();
  }, [id]);

  const startMemoryCreation = () => {
    // 5 dakikalık cookie: jodiacRequest=memoryThree
    document.cookie = `jodiacRequest=memory_tree; max-age=300; path=/`;
    setShowScanner(true);
  };
  useEffect(() => {
    const fetchList = async () => {
      try {
        setLoading(true);
        const response = await getMemoryTreeList();
        if (response && response.success && Array.isArray(response.data)) {
          setList(response.data);
        } else {
          setList([]);
        }
      } catch (err) {
        setError("Liste alınamadı");
        setList([]);
      } finally {
        setLoading(false);
      }
    };
    fetchList();
  }, []);

  const openTree = async (uuid) => {
    setSelectedUuid(uuid);
    setDetail(null);
    setDetailLoading(true);
    try {
      const response = await getMemoryTreeSingle(uuid);
      setDetail(response?.data || null);
      console.log("detail", response?.data);
    } catch (e) {
      setDetail(null);
    } finally {
      setDetailLoading(false);
    }
  };

  if (selectedUuid || showExample) {
    if (detailLoading) {
      return (
        <div className="w-full h-screen min-h-screen flex items-center justify-center bg-[#fff]">
          <div className="flex flex-col items-center justify-center">
            <div className="relative mb-8">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="animate-spin rounded-full h-24 w-24 border-4 border-transparent border-t-[#3DA7B5] border-r-[#3DA7B5] opacity-75"></div>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div
                  className="animate-spin rounded-full h-16 w-16 border-[3px] border-transparent border-b-[#2a8a96] border-l-[#2a8a96] opacity-60"
                  style={{
                    animationDirection: "reverse",
                    animationDuration: "1.5s",
                  }}
                ></div>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#3DA7B5] via-[#2a8a96] to-[#3DA7B5] animate-pulse shadow-2xl"></div>
              </div>
            </div>
            <p className="text-xl font-semibold text-gray-800 animate-pulse">
              Yükleniyor...
            </p>
          </div>
        </div>
      );
    }
    return (
      <MemoryTreeInside 
        data={detail} 
        onBack={() => {
          setSelectedUuid(null);
          setShowExample(false);
          setDetail(null);
        }}
        isExample={showExample}
        id={id}
      />
    );
  }

  // Loading screen
  if (pageLoading || !packageData) {
    return (
      <div className="w-full h-screen min-h-screen flex items-center justify-center bg-[#fff]">
        <div className="flex flex-col items-center justify-center">
          <div className="relative mb-8">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin rounded-full h-24 w-24 border-4 border-transparent border-t-[#3DA7B5] border-r-[#3DA7B5] opacity-75"></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div
                className="animate-spin rounded-full h-16 w-16 border-[3px] border-transparent border-b-[#2a8a96] border-l-[#2a8a96] opacity-60"
                style={{
                  animationDirection: "reverse",
                  animationDuration: "1.5s",
                }}
              ></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#3DA7B5] via-[#2a8a96] to-[#3DA7B5] animate-pulse shadow-2xl"></div>
            </div>
          </div>
          <p className="text-xl font-semibold text-gray-800 animate-pulse">
            Yükleniyor...
          </p>
        </div>
      </div>
    );
  }

  const handleAccept = (id) => {
    // Kabul tıklaması (ileride API entegre edilecek)
    console.log("accepted", id);
  };

  const handleReject = (id) => {
    // Reddet tıklaması (ileride API entegre edilecek)
    console.log("rejected", id);
  };

  // Örnek anı ağacı dummy data
  const exampleMemoryTree = {
    uuid: "example",
    users: {
      user: { name: "Ayşe", profile_picture: "/assets/pngImages/user.png" },
      partner: { name: "Mehmet", profile_picture: "/assets/pngImages/user.png" }
    },
    photos: [
      {
        uuid: "1",
        url: "/assets/placeholder.jpeg",
        description: "İlk tanıştığımız gün",
        created_at: "2024-01-15"
      },
      {
        uuid: "2", 
        url: "/assets/placeholder.jpeg",
        description: "Birlikte ilk tatilimiz",
        created_at: "2024-03-20"
      },
      {
        uuid: "3",
        url: "/assets/placeholder.jpeg", 
        description: "Doğum günü kutlaması",
        created_at: "2024-06-10"
      },
      {
        uuid: "4",
        url: "/assets/placeholder.jpeg",
        description: "Yılbaşı gecesi",
        created_at: "2024-12-31"
      }
    ]
  };

  const showExampleTree = () => {
    setDetail(exampleMemoryTree);
    setShowExample(true);
  };

  if (showScanner) {
    return (
      <div className="min-h-screen bg-white px-4 py-4 flex items-start">
        <div className="max-w-sm mx-auto w-full mt-4">
          <div className="bg-whit rounded-2xl shadow-md  p-6 flex flex-col items-center justify-center">
            <img
              src="/assets/pngImages/scanJodiac.png"
              alt="Scan"
              className="w-40 h-56 object-contain mb-4"
            />
            <div className="text-black text-lg max-w-60 font-semibold ">
              Anı Ağacınızı Paylaşacağınız Kişinin Jodiacını Okutunuz.{" "}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed] relative">
      <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
        {/* ModuleHeader */}
        {packageData && (
          <div className="relative z-30 w-full mb-2">
            <ModuleHeader
              userName={
                packageData.user?.first_name + " " + packageData.user?.last_name
              }
              subtitle={packageData.package?.name + " Modülüne Hoş Geldiniz"}
              title={packageData.package?.name}
              description={packageData.package?.description}
              backgroundImage={packageData.package?.image_url}
              onExpandedChange={setIsHeaderExpanded}
              showToggle={true}
              autoHeight={true}
            />
          </div>
        )}

        <div className="w-full px-4 py-6">
          <div className="max-w-sm mx-auto">
            {/* Anı Oluşturmaya Başlayın Butonu - Modern Tasarım */}
            <button
          onClick={startMemoryCreation}
              className="w-full group relative overflow-hidden bg-gradient-to-r from-[#3DA7B5] to-[#5ABCC8] hover:from-[#2F8894] hover:to-[#4A9BA6] text-white rounded-2xl mb-6 p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
            >
              <div className="relative z-10 flex items-center justify-center gap-3">
                <div className="text-center">
                  <p className="text-white text-lg font-bold mb-1">
                    Anı Oluşturmaya Başlayın
                  </p>
                  <p className="text-white/80 text-sm">
                    Partnerinizle anılarınızı paylaşın
                  </p>
                </div>
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/10 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
            </button>

            {/* Örnek Anı Ağacı Butonu - Sadece liste boşsa göster */}
            {!loading && !error && list.length === 0 && (
              <button
                onClick={showExampleTree}
                className="w-full bg-white border-2 border-[#3DA7B5] text-[#3DA7B5] rounded-2xl mb-6 p-4 shadow-sm hover:shadow-md transition-all duration-200 hover:bg-[#3DA7B5] hover:text-white group"
              >
                <div className="flex items-center justify-center gap-3">
                  <div className="w-8 h-8 bg-[#3DA7B5]/10 rounded-full flex items-center justify-center group-hover:bg-white/20 transition-colors">
                    <img 
                      src="/assets/icons/tree.svg" 
                      alt="Ağaç" 
                      className="w-5 h-5 filter group-hover:brightness-0 group-hover:invert transition-all duration-200"
                      style={{ filter: 'brightness(0) saturate(100%) invert(60%) sepia(100%) saturate(1000%) hue-rotate(180deg)' }}
                    />
                  </div>
                  <div className="text-center">
                    <p className="font-semibold text-sm mb-1">
                      Örnek Anı Ağacı
                    </p>
                    <p className="text-xs opacity-80">
                      Nasıl göründüğünü keşfedin
                    </p>
                  </div>
                </div>
              </button>
            )}

            {/* Liste */}
            <div className="space-y-4">
          {loading && (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#3DA7B5]"></div>
              <span className="ml-3 text-gray-500 text-sm">Yükleniyor...</span>
            </div>
          )}
          {error && !loading && (
            <div className="bg-red-50 border border-red-200 rounded-xl p-4 text-center">
              <div className="text-red-600 text-sm font-medium">{error}</div>
            </div>
          )}
          {!loading && !error && list.length === 0 && (
            <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 text-center">
              <div className="flex justify-center mb-3">
                <img 
                  src="/assets/icons/tree.svg" 
                  alt="Ağaç" 
                  className="w-12 h-12 opacity-40"
                />
              </div>
              <div className="text-gray-600 text-sm font-medium">Henüz anı ağacı bulunmuyor</div>
              <div className="text-gray-400 text-xs mt-1">İlk anı ağacınızı oluşturmak için yukarıdaki butona tıklayın</div>
            </div>
          )}
          {!loading &&
            !error &&
            list.map((item) => (
              <div
                key={item.uuid}
                onClick={() => openTree(item.uuid)}
                className="cursor-pointer bg-white shadow-sm hover:shadow-md rounded-xl border border-gray-100 p-4 transition-all duration-200 hover:border-[#3DA7B5]/30 group"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 min-w-0">
                    <div className="relative">
                      <img
                        src={
                          item.users?.user?.profile_picture ||
                          "/assets/pngImages/user.png"
                        }
                        alt={item.users?.user?.name || "Kullanıcı"}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-[#3DA7B5] rounded-full border-2 border-white"></div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <span className="text-sm text-gray-800 font-semibold truncate block">
                        {item.users?.user?.name || "Kullanıcı"}
                      </span>
                      <span className="text-xs text-gray-500 truncate block">
                        & {item.users?.partner?.name || "Partnerin"}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    <span className="text-xs text-gray-400">→</span>
                  </div>
                </div>
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
